import gql from 'graphql-tag';

export default gql`
    query GetLocationInfo($input: GetLocationInfoInput) {
        getLocationInfo(input: $input) {
            originId
            originType
            originRegionId
            originRegionDescrip
            originDistrictId
            originDistrictDescrip
            destinationId
            destinationType
            destinationRegionId
            destinationRegionDescrip
            destinationDistrictId
            destinationDistrictDescrip
        }
    }
`;
